module.exports = __webpack_public_path__ + "media/images/gif-0d87eff5.png";